import { cn } from '../../utils/cn';
import type { AvatarImageProps } from './Avatar.types';

/**
 * Web avatar image — a plain `<img>` clipped by the Avatar container's
 * rounded circle. `alt=""` on purpose: the container carries the
 * accessibility label (role="img" + aria-label), so the inner element stays
 * silent for screen readers.
 */
export function AvatarImage({ src, className, onError, onLoad }: AvatarImageProps) {
  return (
    <img
      src={src}
      alt=""
      draggable={false}
      // `decoding="async"` lets the browser decode off the main thread so a
      // burst of avatars (hover popover, facepile) doesn't jank the frame.
      decoding="async"
      className={cn('object-cover', className)}
      onError={onError}
      onLoad={onLoad}
    />
  );
}
